import React, {useEffect, useState} from "react";
import axios from "axios";

const MachineList = () => {

  const storedData = localStorage.getItem('liveData');
  const parsedData = JSON.parse(storedData);

  const [Admin, setAdmin] = useState(false);
  const [imgUrl, setImgUrl] = useState({});
  const [infomenu, setInfomenu] = useState({open:false, serialNumber:""})

  let alias
  let serienummer
  let orginazation

  Object.entries(parsedData).forEach(([key, value]) => {
    if (!value.metadata) {
      delete parsedData[key];
    }
  })

  const openMenu = (serialNumber) => {
    if (document.getElementById(serialNumber).style.display === "") {
      document.getElementById(serialNumber).style.display = "flex";
    } else {
      document.getElementById(serialNumber).style.display = ""
    }
  }

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await axios.get('/api/auth/validate-token', { withCredentials: true });
        const user = response.data.user.organization;
        if (user === "admin") {
          setAdmin(true)
        }
      } catch (error) {
        console.log(error)
      }
    };

    checkAuth();
  }, []);

  const DeleteMachine = async () => {
    if (Admin) {
      document.getElementById("popup").style.display = "none";
      window.location.reload();
      await axios.delete(`/api/machine/delete`, {
        params: {
          alias: alias,
          bedrijf: orginazation,
          machine_serial: serienummer,
        }
      });
    }
  }

  const toggleServiceMode = async (e, serial, serviceMode) => {
    if (Admin) {
      document.getElementById("popup").style.display = "none";
      window.location.reload();
      await axios.get(`/api/machine/service`, {
        params: {
          serial: serial,
          serviceMode: serviceMode,
        }
      });
    }
  }

  const copyText = (text) => {
    if (window.isSecureContext) {
      navigator.clipboard.writeText( text )
    }
  }

  const confirmDeleteMachine = async (event, naam, bedrijf, serial) => {
    document.getElementById("popup").style.display = "flex";
    alias = naam;
    orginazation = bedrijf
    serienummer = serial
  }

  const cancelDeleteMachine = async () => {
    document.getElementById("popup").style.display = "none";
  }

  const openInfo = (serialNumber) => {
    setInfomenu({open: true, serialNumber})
    console.log(parsedData)
  }

  const fetchImgUrl = async (serialNumber) => {
    try {
      const response = await axios.get(`/api/img/${serialNumber}`, {
        withCredentials: true,
      });

      if (response.status === 200 && response.data.url) {
        return response.data.url
      } else {
        return null
      }
    } catch (err) {
      return null
    }
  };

  useEffect(() => {
    const fetchImages = async () => {
      for (const item of Object.entries(parsedData)) {
        imgUrl[item[0]] = await fetchImgUrl(item[0]);
      }
      setImgUrl({...imgUrl});
    }

    fetchImages();
  }, [])

  return (
    <div className={"flex w-full px-4"}>
      {Admin ? <dialog open id={"popup"}
                       className={"hidden shadow-sm shadow-gray-400 bg-gray-200 rounded-2xl p-3 w-72 fixed z-50 text-center gap-4 flex-col"}>
        <p className={"font-bold text-2xl"}>Weet je zeker dat je deze machine wilt verwijderen</p>
        <div className="flex items-center justify-around">
          <button className={"p-2 bg-blue-500 rounded-full text-xl font-bold text-white w-16"}
                  onClick={DeleteMachine}>Ja
          </button>
          <button className={"p-2 bg-blue-500 rounded-full text-xl font-bold text-white w-16"}
                  onClick={cancelDeleteMachine}>Nee
          </button>
        </div>
      </dialog> : null}

      {infomenu.open ?
      <div className={"absolute justify-center items-center left-0 top-0 w-full h-full pt-12 bg-gray-500 bg-opacity-30 z-10 flex"}>
        <div className="bg-white rounded-xl w-1/2 h-3/4 text-black flex flex-col items-center text-xl font-bold">
          <span onClick={()=>{setInfomenu({open: false, serialNumber: ""})}}>Back</span>
          <h1>{parsedData[infomenu.serialNumber].metadata.alias}</h1>
          <h1 onClick={copyText(parsedData[infomenu.serialNumber].metadata.serialNumber)}>Machine Serienummer: {parsedData[infomenu.serialNumber].metadata.serialNumber}</h1>
          <h1 onClick={copyText(parsedData[infomenu.serialNumber].metadata.loggerId)}>Logger Serienummer: {parsedData[infomenu.serialNumber].metadata.loggerId}</h1>
          <h1>Bedrijf: {parsedData[infomenu.serialNumber].metadata.cleanorg}</h1>
          <h1>Model: {parsedData[infomenu.serialNumber].metadata.model}</h1>
          <h1>Batterij 1: {parsedData[infomenu.serialNumber].liveData.Soc1}</h1>
          <h1>Batterij 2: {parsedData[infomenu.serialNumber].liveData.Soc2}</h1>
          <h1>Motor Snelheid: {parsedData[infomenu.serialNumber].liveData.MotorSpeed}</h1>
          <h1>Temp 1: {parsedData[infomenu.serialNumber].liveData.Temp1}</h1>
          <h1>Temp 2: {parsedData[infomenu.serialNumber].liveData.Temp2}</h1>
        </div>
      </div>
      : ""}

      <a href={"/"} className={"ml-2 mt-2 font-extrabold text-xl text-white absolute bg-orange-500 rounded-lg h-fit p-1.5 shadow-xl shadow-gray-400"}>Terug</a>

      <ul className={"grid 2xl:grid-cols-2 grid-cols-1 mt-1 gap-6 w-full xl:px-24 xl:mt-5 mt-20 items-center sm:items-stretch"}>
        {parsedData ? Object.entries(parsedData).map(([serialNumber, data]) => (
            <li key={serialNumber}
                className={`bg-white flex p-2 rounded-full shadow relative`}>
              {imgUrl[serialNumber] ? (
                <a href={"/machine/" + serialNumber} className="w-40 h-40 rounded-full items-center relative hidden xl:flex">
                  <img key={serialNumber} src={imgUrl[serialNumber]} alt={data.metadata.alias} className="w-full h-full object-cover rounded-full"/>
                  <div className={"w-10 h-10 absolute top-0 right-0 rounded-full " + (data.liveData.MotorSpeed > 100 ? "bg-green-600" : data.liveData.IsCharging1 || data.liveData.IsCharging2 ? "bg-yellow-400" : "bg-gray-400")}></div>
                </a>
              ) : (
                <div className={"w-40 h-40 bg-gradient-to-br from-orange-500 to-yellow-400 rounded-full items-center relative hidden xl:flex"}>
                  <h1 className={"w-full font-bold text-4xl text-white text-center"}>{data.metadata.alias[0]}</h1>
                  <div className={"w-10 h-10 absolute top-0 right-0 rounded-full " + (data.liveData.MotorSpeed > 100 ? "bg-green-600" : data.liveData.IsCharging1 || data.liveData.IsCharging2 ? "bg-yellow-400" : "bg-gray-400")}></div>
                </div>
              )}
              <div className="flex-col flex items-center justify-around xl:w-4/5 w-full">
                <a className={"text-gray-800 font-extrabold xl:text-4xl text-2xl ml-2 select-none"} href={"/machine/" + serialNumber}>{data.metadata.model}</a>
                <h1 className={"text-gray-600 ml-2 font-semibold xl:text-2xl text-md select-none"}>Serienummer: {serialNumber}</h1>
                <h1 className={"text-gray-600 ml-2 font-semibold xl:text-2xl text-md select-none"}>Bedrijf: {data.metadata.cleanorg}</h1>
                {Admin ? <div>
                  <h1 className={"text-gray-600 ml-2 font-semibold xl:text-2xl text-md"}>Influx serienummer: {data.metadata.loggerId}</h1>
                </div> : <h1 className={"text-gray-600 ml-2 font-semibold xl:text-2xl text-md"}>Merk: {data.metadata.alias}</h1>}
              </div>
              {Admin ?
              <button onClick={() => openMenu(serialNumber)} className={"bg-orange-500 w-10 h-10 rounded-full p-1 absolute right-3 top-3"}><img src={"/menu_icons/gear.svg"} alt={""}/></button>
              : ""}
              {Admin ?
                <div id={serialNumber} className={"bg-white rounded shadow absolute flex-col p-1 gap-1 absolute top-3 right-14 hidden"}>
                  <a href={"edit/" + serialNumber}
                     className={"hover:cursor-pointer bg-blue-500 text-white rounded py-1 px-2"}>Edit</a>
                  <a onClick={(e) => toggleServiceMode(e, data.metadata.serialNumber, data.metadata.serviceMode)}
                    className={"hover:cursor-pointer text-white rounded py-1 px-2 " + (data.metadata.serviceMode?"bg-green-600":"bg-orange-600")}>Service {data.metadata.serviceMode?"(On)":"(Off)"}</a>
                  <a onClick={()=>{openInfo(serialNumber)}}
                     className={"hover:cursor-pointer bg-blue-500 text-white rounded py-1 px-2"}>Info</a>
                  <a onClick={(event) => confirmDeleteMachine(event, data.metadata.alias, data.metadata.organization, serialNumber)}
                    className={"hover:cursor-pointer bg-red-600 text-white rounded py-1 px-2"}>Delete</a>
                </div>
                : ""}
            </li>
          )
        ) : ""}
      </ul>
      {Admin ? <a href={"/machine/nieuw"}
                  className="fixed right-3 bottom-3 w-14 h-14 rounded-full bg-green-600 shadow-xl shadow-gray-400 p-3.5">
        <img src={"/Add.svg"} alt={""}/>
      </a>: ""}
    </div>
  )

}

export default MachineList;